import { ADD_PACKAGE } from '../actions/addPackage'
import { get } from 'lodash'

const availablePackages = (state = {}, action) => {
  return action.type === ADD_PACKAGE
    ? Object.assign({}, state, {
        [action.payload.identifier]: action.payload.cruise
      })
    : state
}

export default availablePackages

export const getRelatedSailings = state => {
  const initialPackageKey = state.initialPackage

  const allPackages = state.availablePackages
  const availableRelatedSailing = Object.values(allPackages || {}).reduce(
    (arr, cruise) => {
      if (cruise.identifier !== initialPackageKey) {
        const {
          identifier,
          sailDate,
          destinationName,
          shipName,
          stateRoomData,
          sailingNights,
          description
        } = cruise

        const guestCountPricing =
          stateRoomData && stateRoomData.guestCountPricing
            ? Object.entries(stateRoomData.guestCountPricing).reduce(
                (obj, [superCatKey, pricing]) => {
                  if (pricing && pricing.bestGuestCountRate) {
                    obj[superCatKey] = pricing
                  }

                  return obj
                },
                {}
              )
            : null
        if (guestCountPricing) {
          const taxes = get(
            Object.values(guestCountPricing || {}),
            '0.bestGuestCountRate.priceInfo.taxesFees',
            null
          )
          const taxesFeesIncluded = get(
            Object.values(guestCountPricing || {}),
            '0.bestGuestCountRate.priceInfo.taxesFeesIncluded',
            false
          )
          arr.push({
            identifier,
            sailDate,
            destinationName,
            tableDescription: `${
              sailingNights ? sailingNights + ' Night' : ''
            } ${description}`,
            description,
            shipName,
            sailingNights,
            guestCountPricing,
            currency: cruise.currency,
            currencySymbol: cruise.currencySymbol,
            taxes: taxes && +taxes ? taxes.toFixed(2) : null,
            taxesFeesIncluded
          })
        }
      }

      return arr
    },
    []
  )

  return availableRelatedSailing.length ? availableRelatedSailing : null
}
